import React from "react";
import Routes from './Routes';
import { ProgressProvider } from './context/ProgressContext';

function App() {
  return (
    <ProgressProvider>
      <Routes />
    </ProgressProvider>
  );
}

export default App;